"use strict";
import AppLog from "../../logger";
import * as Pre from "../../actions/_PreActionNames";
import * as Actions from "../../actions/_ActionTypes";
import * as CONSTS from "../../../assets/consts";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import { Platform, ToastAndroid } from "react-native";
import * as Network from "expo-network";
import { ShowSplashScreen } from "../../actions/AppActions";
import { Notifications } from "react-native-notifications";
import ExpoConstants from "expo-constants";
import { translate } from "../../../src/locales/translate";
import { convertHttpToWsUri, convertWsToHttpUri } from "../../util";
import { connectToBuilding } from "../../hooks/connectToServer/connectToBuilding";
import { batch } from "react-redux";
import {
  scheduleNotificationAsync,
  setNotificationHandler,
} from "expo-notifications";
const axios = require("axios").default;
var httpClient = axios.create();
//exports.__esModule = true;
const IS_WEB = Platform.OS == "web";
const actionsToInit = [
  // QUICK_ACCESS
  //this.TLStore.dispatch

  {
    type: "USER_GET_DEVICE_QUICK_ACCESS",
    payload: null,
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //AREA_ALL
  {
    type: "AREA_ALL",
    payload: null,
    socket: { send: false, keepSocket: true },
    url: "/Areas/All",
    accessToken: undefined,
  },
  //DEVICE_ALL
  {
    type: "DEVICE_ALL",
    payload: { areaId: 0, liteMode: true },
    socket: { send: false, keepSocket: true }, // set socket.send = false and set valid url to use http instead of ws
    url: "/Devices/All?liteMode=true",
    accessToken: undefined,
  },
  //DEVICE_TYPE_EVENTS
  {
    type: "DEVICE_TYPE_EVENTS",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //AREA_TYPE_EVENTS
  {
    type: "AREA_TYPE_EVENTS",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //AREA_TYPE_ACTIONS
  {
    type: "AREA_TYPE_ACTIONS",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //SCENARIO_ALL
  {
    type: "SCENARIO_ALL",
    payload: {},
    socket: { send: false, keepSocket: true },
    url: "/Scenarios/AllLite",
    accessToken: undefined,
  },
  //CAMERA_SERVER
  {
    type: "CAMERA_SERVER",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //APPWIDGET_ALL
  {
    type: "APPWIDGET_ALL",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },
  //USERMESSAGE_NEW_MESSAGES_COUNT
  {
    type: "USERMESSAGE_NEW_MESSAGES_COUNT",
    //payload: { areaId: 0 },
    socket: { send: false, keepSocket: true }, // set socket.send = false and set valid url to use http instead of ws
    url: "/UserMessages/NewMessagesCount",
    accessToken: undefined,
  },
  // SMARTPARKING_ALL
  {
    type: "SMARTPARKING_ALL",
    socket: { send: false, keepSocket: true }, // set socket.send = false and set valid url to use http instead of ws
    url: "/SmartParking/All",
    accessToken: undefined,
  },
  // USER_GET_SESSIONS
  {
    type: "USER_GET_SESSIONS",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },  
  // ACCESSCONTROL_ACK_ALL
  {
    type: "ACCESSCONTROL_ACK_ALL",
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken: undefined,
  },

];

function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

function waitForSocket(socket, callback) {
  setTimeout(function () {
    try {
      socket.readyState === 1 ? callback() : waitForSocket(socket, callback);
    } catch (error) {
      waitForSocket(socket, callback);
    }
  }, 10);
}

const handleGuestWillTimeoutNotification = (n) => {
  if (n && n.data) {
    let parsedData = JSON.parse(n.data);
    let { guestFullName, timeLeft, guestId } = parsedData;
    let title = translate("user.guestExpireNotificationTitle");
    let body = "";
    let data = {};
    if (guestId) {
      // admin mode
      body = translate("user.guestWillExpireIn", { guestFullName, timeLeft });
      data = { guestId };
    } else {
      // guest itself
      body = translate("user.youWillExpireIn", { timeLeft });
    }

    Notifications.postLocalNotification({
      title,
      body,
      data,
      android: {
        channelId: CONSTS.NOTIFICATION_CHANNELS.GUESTS_TIMEOUT,
      },
    });
  }
};

const handleGuestDidTimeoutNotification = (n) => {
  if (n && n.data) {
    let parsedData = JSON.parse(n.data);
    let { guestFullName, areas, guestId } = parsedData;
    let title = translate("user.guestExpireNotificationTitle");
    let body = "";
    let data = {};
    if (guestId) {
      // admin mode
      body = translate("user.guestDidExpire", {
        guestFullName,
      });
      data = { guestId };
    } else {
      // guest itself
      body = translate("user.youDidExpire");
      if (Array.isArray(areas) && areas.length > 0) {
        body += `\r\n(${translate("areaType.UNIT")}: ${areas.join(",")})`;
      }
    }

    Notifications.postLocalNotification({
      title,
      body,
      data,
      android: {
        channelId: CONSTS.NOTIFICATION_CHANNELS.GUESTS_TIMEOUT,
      },
    });
  }
};

const handleScenarioReportNotification = (n) => {
  if (n && n.data) {
    let parsedData = JSON.parse(n.data);
    let { scenarioName, succeeded, messageBody } = parsedData;
    let title = translate("scenario.scenarioExecutionReport"),
      body = "";
    if (succeeded) {
      body =
        messageBody ||
        translate("scenario.scenarioExecutionReportSucceeded", {
          scenarioName,
        });
    } else {
      body =
        messageBody ||
        translate("scenario.scenarioExecutionReportFailed", {
          scenarioName,
        });
    }

    let data = {};
    Notifications.postLocalNotification({
      title,
      body,
      data,
      android: {
        channelId: CONSTS.NOTIFICATION_CHANNELS.SCENARIO_REPORTS,
      },
    });
  }
};
const handleDoorbellPressNotification = (n) => {
  if (n && n.data) {
    let parsedData = JSON.parse(n.data);
    let { cameraId, cameraName } = parsedData;
    let title = translate("device.doorbellPressedNotificationTitle"),
      body = cameraName;
    let data = {
      cameraId,
      cameraName,
      channel: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
    };

    // setNotificationHandler({
    //   handleNotification: async () => ({
    //     shouldShowAlert: true,
    //     shouldPlaySound: true,
    //     shouldSetBadge: false,
    //   }),
    // });
    // // console.log("title", title);
    // // console.log("body", body);
    // // console.log("data", data);
    // // Second, call the method

    // scheduleNotificationAsync({
    //   content: {
    //     title,
    //     body,
    //     data,
    //   },
    //   trigger: null,
    // });
    // // return
    // Notifications.postLocalNotification({
    //   title,
    //   body,
    //   data,
    //   android: {
    //     channelId: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
    //   },
    //   categoryId: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
    // });
    return;
  }
};

var socket = null;
var socketHandler = {
  serverUrl: undefined,
  canGetDataOnConnected: false,
  shouldReconnectOnError: true,
  connectionRetry: 0,
  buildingInfo: {
    buildingId: undefined,
    serverId: undefined,
    cloudServerId: undefined,
    publicAddress: undefined,
  },
  currentServerInfo: null,
  onAction: (event) => {
    console.log("socketHandler.onAction not implemented");
  },
  onNotify: (n) => {
    console.log("socketHandler.onNotify not implemented");
  },
  onConnect: () => {
    console.log("socketHandler.onConnect not implemented");
  },
  onDisConnect: () => {
    console.log("socketHandler.onDisConnect not implemented");
  },

  onMaxRetry: () => {
    console.log("socketHandler.onMaxRetry not implemented");
  },
  onForceInit: async (socket, buildingId = null) => {
    var accessToken = await SecureStore.getItemAsync(CONSTS.ACCESS_TOKEN);
    var serverUrl = await SecureStore.getItemAsync(CONSTS.SERVER_URL);
    // console.log(accessToken);
    // console.log(serverUrl);
    function trySend() {
      socketHandler.sendClientInfoToServer(
        serverUrl,
        accessToken,
        "Client info on init"
      );
      for (var i in actionsToInit) {
        var action = {
          type: actionsToInit[i].type,
          payload: { ...actionsToInit[i].payload },
          buildingId,
          accessToken: accessToken,
          socket: {
            send: true,
            keepSocket: true,
          },
        };

        var actionJson = JSON.stringify(action);

        if (actionsToInit[i]?.socket?.send) {
          if (actionsToInit[i]?.type == "APPWIDGET_ALL") {
            // reset widgets before call APPWIDGET_ALL
            socketHandler.onAction({
              data: JSON.stringify({
                type: "APPWIDGET_CLEAR",
                socket: { send: false, keepSocket: true },
              }),
            });
          }

          socket.send(actionJson);
        } else if (actionsToInit[i]?.url) {
          let { url, type } = actionsToInit[i];
          var _url = serverUrl || "";
          if (_url.endsWith("/") && url.startsWith("/")) url = url.substring(1);
          _url += url;
          if (buildingId) {
            if (!_url.includes("?")) _url += `?buildingId=${buildingId}`;
            else _url += `&buildingId=${buildingId}`;
          }
          var _retryOnFailure = 1;
          socketHandler.tryCallHttp(
            _url,
            accessToken,
            actionJson,
            (resj, _actionJson) => {
              // success callback
              if (resj) {
                if (resj.status == 404) {
                  // if url not found, try with websocket
                  socket.send(_actionJson);
                } else {
                  // else, resj may include an array, object or a single value.
                  var actionToDispatch = {
                    type: type,
                    payload: { data: JSON.stringify(resj) },
                    accessToken: accessToken,
                    socket: {
                      send: false,
                      keepSocket: true,
                    },
                  };
                  socketHandler.onAction({
                    data: JSON.stringify(actionToDispatch),
                  });
                }
              }
            },
            _retryOnFailure,
            (actionJson) => {
              // failure callback
              //console.log("http call failed. try websocket");
              socket.send(actionJson);
            }
          );
        }

        // action.accessToken = accessToken;
      }
    }

    //console.log(`forceInit on socketMiddleware_socketHandler`)
    if (accessToken) {
      if (socket.readyState != WebSocket.OPEN) {
        setTimeout(() => {
          trySend();
        }, 3000);
      } else {
        trySend();
      }

      socketHandler.canGetDataOnConnected = true;
    }
  },
  onUpdateReducer: () => {
    console.log("socketHandler.onUpdateReducer not implemented");
  },

  tryCallHttp: (
    _url = "",
    accessToken = "",
    actionJson,
    successCallback = (result) => {},
    retryOnFailure = 0,
    failureCallback = (actionJson) => {}
  ) => {
    fetch(_url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          return res.json();
        } else {
          // console.log("failed to open", _url, "with status", res.status);
          return { status: res.status };
        }
      })
      .then((resj) => {
        typeof successCallback == "function" &&
          successCallback(resj, actionJson);
      })
      .catch((e) => {
        var logMessage = `error on socketMiddleware when fetch ${_url}\r\n${e}`;
        //console.log(logMessage, "retryOnFailure", retryOnFailure - 1);
        const serverInfo = socketHandler.currentServerInfo;
        if (serverInfo) {
          var logServerUlr = convertWsToHttpUri(
            socketHandler.serverUrl,
            serverInfo?.ports
          );
          AppLog(httpClient, logServerUlr, logMessage, "ERROR", 0);
          if (retryOnFailure > 0) {
            retryOnFailure--;
            // console.log("retry", _url);
            socketHandler.tryCallHttp(
              _url,
              accessToken,
              actionJson,
              successCallback,
              retryOnFailure,
              failureCallback
            );
          } else {
            typeof failureCallback == "function" && failureCallback(actionJson);
          }
        }
      });
  },

  sendClientInfoToServer: async (
    serverUrl = "",
    accessToken = "",
    customMessage = ""
  ) => {
    var connection = {};
    var logCode = 1312;
    try {
      // includes: isConnected, type, isInternetReachable
      var netStat = await Network.getNetworkStateAsync();
      connection = netStat;
      if (
        Platform.OS === "web" &&
        ExpoConstants.platform &&
        ExpoConstants.platform.web &&
        ExpoConstants.platform.web.ua
      ) {
        connection.userAgent = ExpoConstants.platform.web.ua;
      }
    } catch (e) {
      console.log(e);
    }
    var payload = {
      description: customMessage,
      clientVersion: CONSTS.APP_VERSION,
      connection,
      platform: Platform.OS,
      serverUrl,
      accessToken,
    };

    AppLog(httpClient, serverUrl, JSON.stringify(payload), "INFO", logCode);
  },
};
export default function (serverUrl) {
  socketHandler.serverUrl = serverUrl;
  const startSocket = (serverUrl) => {
    // console.log(`try opening websocket to server    ${serverUrl}`);
    socket = new WebSocket(serverUrl);
    socket.onopen = () => {
      // console.log(
      //   `websocket ${socket._socketId} connected to server    ${serverUrl}, opened`
      // );
      if (socketHandler.serverUrl != serverUrl) {
        socketHandler.serverUrl = serverUrl;
      }
      socketHandler.onConnect();
      socketHandler.connectionRetry = 0;
      SecureStore.getItemAsync(CONSTS.ACCESS_TOKEN)
        .then((accessToken) => {
          if (accessToken) {
            SecureStore.getItemAsync(CONSTS.SESSION_ID)
              .then((sessionId) => {
                var payload = {
                  type: "CONNECTION_INIT",
                  accessToken,
                  payload: { sessionId },
                  socket: {
                    send: true,
                    keepSocket: true,
                  },
                };
                var payloadStr = JSON.stringify(payload);
                socket.send(payloadStr);
              })
              .catch((e) => {
                socketHandler.onConnect();
                var payload = {
                  type: "CONNECTION_INIT",
                  accessToken,
                  payload: {},
                  socket: {
                    send: true,
                    keepSocket: true,
                  },
                };
                var payloadStr = JSON.stringify(payload);
                socket.send(payloadStr);
              });
          }
        })
        .catch(console.log);
    };

    socket.onclose = () => {
      // console.log(`web socket ${socket._socketId} closed.`);
      socketHandler.onDisConnect();
      // socket = null;
      setTimeout(() => {
        var _serverUrl = socketHandler.serverUrl || serverUrl;
        if (
          socketHandler.shouldReconnectOnError &&
          socketHandler.connectionRetry < 2
        ) {
          socketHandler.connectionRetry += 1;
          // console.log(
          //   `try to reopen socket with serverUrl ${_serverUrl} , ${socketHandler.connectionRetry}`
          // );
          // if still less than 3, use normal way
          startSocket(_serverUrl);
          // else try with localAddress if exists
          // else {
          //   Network.getNetworkStateAsync()
          //     .then((netState) => {
          //       if (netState.isConnected) {
          //         var _publicAddress =
          //           socketHandler.buildingInfo?.publicAddress;
          //         // === find server by active building serverId ===
          //         SecureStore.Servers.findServer(
          //           socketHandler.buildingInfo?.serverId ||
          //             socketHandler.buildingInfo?.cloudServerId
          //         )
          //           .then((serverInfo) => {
          //             _publicAddress = serverInfo.publicAddress;
          //           })
          //           .catch((err) => console.log("find server", err));
          //         // === convert http to ws ===
          //         var publicWsAddress = convertHttpToWsUri(_publicAddress);
          //         // if type id CELLULAR and WEB
          //         if (IS_WEB) {
          //           // socketHandler.onMaxRetry();
          //           startSocket(_serverUrl);
          //         } else {
          //           if (netState.type == "CELLULAR") {
          //             if (socketHandler.buildingInfo.buildingId) {
          //               connectToBuilding(socketHandler.buildingInfo.buildingId)
          //                 .then((serverInfo) => {
          //                   if (serverInfo) {
          //                     const addressWsAddress = convertHttpToWsUri(
          //                       serverInfo.address
          //                     );
          //                     startSocket(addressWsAddress);
          //                     socketHandler.onUpdateReducer(
          //                       serverInfo.serverInfo
          //                     );
          //                   } else {
          //                     socketHandler.onMaxRetry();
          //                   }
          //                 })
          //                 .catch((err) => {
          //                   console.log("error fetch serverInfo ", err);
          //                   socketHandler.onMaxRetry();
          //                 });
          //             }
          //             // httpClient.defaults.timeout = 5000;
          //             // getServerInfo(httpClient, _publicAddress)
          //             //   .then((serverInfo) => {
          //             //     if (serverInfo) {
          //             //       startSocket(publicWsAddress);
          //             //     } else {
          //             //       socketHandler.onMaxRetry();
          //             //     }
          //             //   })
          //             //   .catch((err) => {
          //             //     console.log("error fetch serverInfo ", err);
          //             //     socketHandler.onMaxRetry();
          //             //   });
          //             else {
          //               socketHandler.onMaxRetry();
          //             }
          //           }
          //           // re try with currentBuilding localAddress
          //           else if (netState.type !== "CELLULAR") {
          //             SecureStore.Buildings.getCurrentBuilding().then(
          //               (currentBuilding) => {
          //                 if (currentBuilding) {
          //                   connectToBuilding(currentBuilding.buildingId).then(
          //                     (serverInfo) => {
          //                       if (serverInfo) {
          //                         var localWsAddress = convertHttpToWsUri(
          //                           serverInfo?.address
          //                         );
          //                         if (localWsAddress) {
          //                           startSocket(localWsAddress);
          //                           socketHandler.onUpdateReducer(
          //                             serverInfo.serverInfo
          //                           );
          //                         } else {
          //                           socketHandler.onMaxRetry();
          //                         }
          //                       } else {
          //                         startSocket(_publicAddress);
          //                         //socketHandler.onMaxRetry();
          //                       }
          //                     }
          //                   );

          //                   // if (localWsAddress != _serverUrl) {
          //                   //   startSocket(localWsAddress);
          //                   // } else {
          //                   //   if (_serverUrl != publicWsAddress) {
          //                   //     httpClient.defaults.timeout = 5000;
          //                   //     getServerInfo(httpClient, _publicAddress)
          //                   //       .then((serverInfo) => {
          //                   //         if (serverInfo) {
          //                   //           startSocket(publicWsAddress);
          //                   //         } else {
          //                   //           socketHandler.onMaxRetry();
          //                   //         }
          //                   //       })
          //                   //       .catch((err) => {
          //                   //         console.log("error fetch serverInfo ", err);
          //                   //         socketHandler.onMaxRetry();
          //                   //       });
          //                   //   } else {
          //                   //     socketHandler.onMaxRetry();
          //                   //   }
          //                   // }
          //                 } else {
          //                   startSocket(_publicAddress);
          //                   //socketHandler.onMaxRetry();
          //                 }
          //               }
          //             );
          //           }
          //         }
          //       } else {
          //         socketHandler.onMaxRetry();
          //       }
          //     })
          //     .catch((e) =>
          //       console.log("error on try connect with local address", e)
          //     );
          // }
        } else if (socketHandler.connectionRetry >= 2) {
          Network.getNetworkStateAsync()
            .then((netState) => {
              if (netState.isConnected) {
                var _publicAddress = socketHandler.buildingInfo?.publicAddress;
                // === find server by active building serverId ===
                SecureStore.Servers.findServer(
                  socketHandler.buildingInfo?.serverId ||
                    socketHandler.buildingInfo?.cloudServerId
                )
                  .then((serverInfo) => {
                    _publicAddress = serverInfo?.publicAddress;
                  })
                  .catch((err) => console.log("find server", err));
                // === convert http to ws ===
                // var publicWsAddress = convertHttpToWsUri(_publicAddress);
                // if type id CELLULAR and WEB
                if (IS_WEB) {
                  socketHandler.onMaxRetry();
                  // startSocket(_serverUrl);
                } else {
                  if (netState.type == "CELLULAR") {
                    if (socketHandler.buildingInfo.buildingId) {
                      connectToBuilding(socketHandler.buildingInfo.buildingId)
                        .then((serverInfo) => {
                          if (serverInfo) {
                            socketHandler.onUpdateReducer(serverInfo);
                            const addressWsAddress = convertHttpToWsUri(
                              serverInfo.address,
                              serverInfo?.serverInfo?.ports
                            );
                            startSocket(addressWsAddress);
                          } else {
                            socketHandler.onMaxRetry();
                          }
                        })
                        .catch((err) => {
                          console.log("error fetch serverInfo ", err);
                          socketHandler.onMaxRetry();
                        });
                    }
                    // httpClient.defaults.timeout = 5000;
                    // getServerInfo(httpClient, _publicAddress)
                    //   .then((serverInfo) => {
                    //     if (serverInfo) {
                    //       startSocket(publicWsAddress);
                    //     } else {
                    //       socketHandler.onMaxRetry();
                    //     }
                    //   })
                    //   .catch((err) => {
                    //     console.log("error fetch serverInfo ", err);
                    //     socketHandler.onMaxRetry();
                    //   });
                    else {
                      socketHandler.onMaxRetry();
                    }
                  }
                  // re try with currentBuilding localAddress
                  else if (netState.type !== "CELLULAR") {
                    SecureStore.Buildings.getCurrentBuilding().then(
                      (currentBuilding) => {
                        if (currentBuilding) {
                          connectToBuilding(currentBuilding.buildingId).then(
                            (serverInfo) => {
                              if (serverInfo) {
                                var localWsAddress = convertHttpToWsUri(
                                  serverInfo?.address,
                                  serverInfo?.serverInfo?.ports
                                );
                                if (localWsAddress) {
                                  startSocket(localWsAddress);
                                  socketHandler.onUpdateReducer(serverInfo);
                                } else {
                                  socketHandler.onMaxRetry();
                                }
                              } else {
                                startSocket(_publicAddress);
                                //socketHandler.onMaxRetry();
                              }
                            }
                          );

                          // if (localWsAddress != _serverUrl) {
                          //   startSocket(localWsAddress);
                          // } else {
                          //   if (_serverUrl != publicWsAddress) {
                          //     httpClient.defaults.timeout = 5000;
                          //     getServerInfo(httpClient, _publicAddress)
                          //       .then((serverInfo) => {
                          //         if (serverInfo) {
                          //           startSocket(publicWsAddress);
                          //         } else {
                          //           socketHandler.onMaxRetry();
                          //         }
                          //       })
                          //       .catch((err) => {
                          //         console.log("error fetch serverInfo ", err);
                          //         socketHandler.onMaxRetry();
                          //       });
                          //   } else {
                          //     socketHandler.onMaxRetry();
                          //   }
                          // }
                        } else {
                          startSocket(_publicAddress);
                          //socketHandler.onMaxRetry();
                        }
                      }
                    );
                  }
                }
              } else {
                socketHandler.onMaxRetry();
              }
            })
            .catch((e) =>
              console.log("error on try connect with local address", e)
            );
        } else {
          socketHandler.onMaxRetry();
          // reset to true for next time
          socketHandler.shouldReconnectOnError = true;
        }
      }, 2000);
    };

    socket.onerror = (err) => {
      // console.log(`error on web socket with id ${socket._socketId}\r\n`, err);
    };

    socket.onmessage = (event) => {
      // if (event.data.indexOf("NOTIFY_") >= 0 && socketHandler.onNotify) {
      //   socketHandler.onNotify(JSON.parse(event.data));
      // } else
      if (socketHandler.onAction) {
        socketHandler.onAction(event);
      }
      // === replace by MessageToast.tsx component ===
      // else if (event.data.indexOf("APP_TOAST") >= 0) {
      //   socketHandler.onToast(JSON.parse(event.data).payload);
      // }
    };

    socketHandler.onNotify = (n) => {
      if (n && n.type && n.payload) {
        switch (n.type) {
          case Pre.NOTIFY + Actions.WILL_TIMEOUT:
            handleGuestWillTimeoutNotification(n.payload);
            break;
          case Pre.NOTIFY + Actions.DID_TIMEOUT:
            handleGuestDidTimeoutNotification(n.payload);
            break;
          case Pre.NOTIFY + Actions.SCENARIO_REPORTS:
            handleScenarioReportNotification(n.payload);
            break;
          case Pre.NOTIFY + Pre.DOORBELL + Actions.PRESSED:
            handleDoorbellPressNotification(n.payload);
            break;
          case Pre.NOTIFY + Actions.TEST:
            Notifications.postLocalNotification({
              title: "notification from taplife controller",
              body: JSON.stringify(n.payload),
              android: {
                channelId: CONSTS.NOTIFICATION_CHANNELS.GUESTS_TIMEOUT,
              },
            });
            break;
        }
      }
    };

    socketHandler.onToast = (payload) => {
      if (Platform.OS === "android" && payload && payload.data) {
        var data = JSON.parse(payload.data);
        if (data && data.message)
          ToastAndroid.show(data.message, data.duration || ToastAndroid.SHORT);
      }
    };
  };

  if (!socket || socket.readyState > 1) {
    startSocket(serverUrl);
  }

  return function (store) {
    const queueOnActionArray = [];

    socketHandler.onAction = function (event) {
      var act = JSON.parse(event.data);

      queueOnActionArray.push(act);
      if (queueOnActionArray.length !== 0) {
        const queueIntervalId = setInterval(() => {
          // console.log("queueOnActionArray", queueOnActionArray);
          if (queueOnActionArray.length == 0) {
            clearInterval(queueIntervalId);
          }
          return batch(() => {
            queueOnActionArray.forEach((element) => {
              store.dispatch(element);
            });
            queueOnActionArray.length = 0;
          });
        }, 300);
      }
    };

    socketHandler.onConnect = function () {
      socketHandler.connectionRetry = 0;
      var connectedPayload = {
        type: "APP_CONNECTED",
        socket: {
          send: false,
          keepSocket: true,
        },
      };
      store.dispatch(connectedPayload);
      // console.log(
      //   "APP_CONNECTED in socketMiddleware, socketHandler.canGetDataOnConnected",
      //   socketHandler.canGetDataOnConnected
      // );
      if (socketHandler.canGetDataOnConnected) {
        SecureStore.getBuildingId()
          .then((buildingId) => {
            // console.log('buildingId on force init (re connect socket)', buildingId)
            socketHandler.onForceInit(socket, buildingId);
          })
          .catch((e) => {
            console.log("error on force init (re connect socket)", e);
          });
      }
    };
    socketHandler.onUpdateReducer = function (serverInfo) {
      const serverInfoDispatch = {
        type: Actions.UPDATE_APP_REDUCER,
        payload: serverInfo.severInfo,
        socket: {
          send: false,
          keepSocket: true,
        },
      };
      const serverUrlDispatch = {
        type: Pre.APP + Actions.UPDATE_SERVER_URL,
        payload: serverInfo.address,
        socket: {
          send: false,
          keepSocket: true,
        },
      };
      store.dispatch(serverUrlDispatch);
      store.dispatch(serverInfoDispatch);
    };
    socketHandler.onDisConnect = function () {
      var connectedPayload = {
        type: "APP_DISCONNECTED",
        socket: {
          send: false,
          keepSocket: true,
        },
      };
      store.dispatch(connectedPayload);
    };

    socketHandler.onMaxRetry = () => {
      socketHandler.connectionRetry = 0;
      store.dispatch(ShowSplashScreen(true));
    };

    return function (next) {
      return function (action) {
        if (action.type == Actions.FORCE_INIT) {
          var buildingId = null;
          if (action.payload) buildingId = action.payload.buildingId ?? null;
          if (buildingId) {
            socketHandler.onForceInit(socket, buildingId);
          } else {
            SecureStore.getBuildingId()
              .then((buildingId) => {
                socketHandler.onForceInit(socket, buildingId);
              })
              .catch((e) => {
                console.log("error on get buildingId to forceInit", e);
              });
          }
        }
        if (action.socket && action.socket.send) {
          if (!action.socket.keepSocket) {
            var _action = action,
              _socket = _action.socket,
              action2 = _objectWithoutProperties(_action, ["socket"]);

            action = action2;
          }
          waitForSocket(socket, function () {
            // add buildingId to actions before send to server
            if (socketHandler.buildingInfo.buildingId)
              action.buildingId = socketHandler.buildingInfo.buildingId;
            return socket.send(JSON.stringify(action));
          });
        }
        if (action.type == "APP_RECONNECT") {
          const serverUrlDispatch = {
            type: Pre.APP + Actions.UPDATE_SERVER_URL,
            payload: action.payload.newServerUrl,
            socket: {
              send: false,
              keepSocket: true,
            },
          };
          var newUrl = convertHttpToWsUri(
            action.payload.newServerUrl,
            socketHandler?.currentServerInfo?.ports
          );
          // console.log(`APP_RECONNECT received to reconnect to ${newUrl}`);
          store.dispatch(serverUrlDispatch);
          socketHandler.shouldReconnectOnError = true;
          socketHandler.serverUrl = newUrl;
          socket.close();
        }
        // if (action.type == "LOGOUT") {
        //   // console.log(`close socket due to LOGOUT in socket middleware`);
        //   socketHandler.shouldReconnectOnError = false;
        //   socket.close();
        // }

        // intercept on APP_BUILDING_UPDATE to fetch current building id
        if (
          // action.type == "APP_GET_CURRENT_BUILDING" &&
          action.type == "APP_UPDATE_CURRENT_BUILDING" &&
          socketHandler.buildingInfo
        ) {
          // console.log('action.payload', action.payload)
          // console.log("buildingId updated in socket middleware");
          socketHandler.buildingInfo.buildingId = action.payload?.buildingId;
          socketHandler.buildingInfo.serverId = action.payload?.serverId;
          socketHandler.buildingInfo.cloudServerId =
            action.payload?.cloudServerId;
        }
        if (
          action.type == "APP_UPDATE_CURRENT_SERVER" &&
          socketHandler.buildingInfo
        ) {
          if (action.payload?.publicAddress) {
            socketHandler.currentServerInfo = action.payload;
            socketHandler.buildingInfo.publicAddress =
              action.payload.publicAddress;
          }
        }

        return next(action);
      };
    };
  };
}
